import { chat } from '@/api.js'
import io from 'socket.io-client'
import config from '@/config'
import * as utils from '@/utils.js'
import { Message } from 'element-ui'
const wsUrl = config.socketUrl
const socket = io(wsUrl, { transports: ['websocket'] })
// console.log(router)
// initial state
const state = {
  chat_list: [], // 消息会话
  message_list: [], // 当前消息列表
  newPull_message: [], // 新拉的消息
  peer_uid: '', // 当前选择的会话peer_uid
  dialog_id: '',
  customer_id: '', // 当前登录用户id
  peer_name: '',
  peer_phone: '', // 当前登录用户手机号
  mobile: '', // 当前聊天人手机号
  msgTimestamp: 0,
  sendTimestamp: 0,
  chatListTimestamp: 0,
  tipsTimestamp: 0,
  hasChatData: true,
  hasMsgData: true,
  loadType: 1, // 1加载新消息 2加载历史消息  用于判断是插入消息列表前还是后面
  pullMsg: {},
  unread: 0,
  defalutIconUrl: 'http://s.yimutian.com/avatar/aben.jpg', // 默认头像
  notice_count: 0
}
// getters
const getters = {
  // 获取出需要修改消息状态的消息id
  message_ids(state) {
    let newmsgId = (state.peer_uid && state.newPull_message) || []
    return newmsgId.map(v => {
      return v.id
    })
  },
  dialog_id(state) {
    if (state.peer_uid && state.chat_list.length) {
      let curChat =
      state.chat_list.find(item => item.peer_uid === state.peer_uid) || {}
      return curChat.dialog_id
    }
  },
  peer_name(state) {
    if (state.peer_uid && state.chat_list.length) {
      let curChat =
      state.chat_list.find(item => item.peer_uid === state.peer_uid) || {}
      return curChat.peer_name
    }
  },
  mobile(state) {
    if (state.peer_uid && state.chat_list.length) {
      let curChat =
        state.chat_list.find(item => item.peer_uid === state.peer_uid) || {}
      return curChat.mobile
    }
  }
}
// actions
const actions = {
  chatList(context, param) {
    return chat.chatList(param).then(res => {
      if (res.data.status === 0) {
        context.commit('updatechatList', { data: res.data, param: param })
      }
    })
  },
  newMsgAll(context, param) {
    return chat.newMsg(param).then(res => {
      state.loadType = 1
      if (res.data.status === 0) {
        let msgList =
        state.peer_uid &&
        res.data.result.find(item => Number(item.peer_uid) === state.peer_uid)
        let tipsList =
        state.peer_uid &&
        res.data.tips.find(
          item => Number(item.customer_id) === state.peer_uid
        )
        if (msgList) {
          state.defalutIconUrl = msgList.peer_icon_url
          context.commit('updateHistoryMsg', msgList.msg)
        }
        if (tipsList) {
          context.commit('updateHistoryMsg', tipsList.msg)
          state.tipsTimestamp = new Date()
        }
      }
    })
  },
  historyMsg(context, param) {
    return chat.historyMsg(param).then(res => {
      if (res.data.status === 0) {
        state.loadType = 2
        state.current_people = res.data.display_name
        context.commit('updateHistoryMsg', res.data)
      }
    })
  },
  send(context, param) {
    if (!param.message_content) {
      return
    }
    return new Promise(resolve => {
      return chat.send(param).then(res => {
        if (res.data.status === 0) {
          state.loadType = 1
          state.sendTimestamp = new Date()
          resolve(res.data)
        // context.commit('updateHistoryMsg', res.data)
        } else {
          let tipsMsg = res.data.tips ? res.data.tips[0].msg[0].content : ''
          Message.info({
            message: tipsMsg || (res.data.msg) || (res.popub && res.popub.pop_payload.title) || res.data.user_msg || res.data.errmsg || '发送失败'
          })
        }
      })
    })
  },
  updateHistoryMsg: ({ commit }, msg) => commit('updateHistoryMsg', msg)
}

// mutations
const mutations = {
  updatechatList(state, data) {
    let compare = utils.compare
    if (data.param && data.param.page === 0) {
      state.chat_list = []
    }
    if (data.data.result && data.data.result.length === 0) {
      state.hasChatData = false
    }
    state.notice_count = 0
    state.customer_id = data.data.customer_id
    state.chat_list = state.chat_list
      .concat(data.data.result)
      .sort(compare('action_time'))
  },
  updateHistoryMsg(state, data) {
    let value = data.result ? data.result : data
    if (value.length === 0) {
      state.hasMsgData = false
      return
    }
    state.newPull_message = value.constructor === Array ? value : [value]
    if (state.loadType === 1) {
      state.message_list = state.message_list.concat(value)
    } else {
      state.message_list = value.concat(state.message_list)
    }
    if (state.chat_list.length) {
      state.unread =
        state.peer_uid &&
        state.chat_list.find(item => item.peer_uid === state.peer_uid)
          .unread_count
    }
  }
}
// socket
socket.on('connect', () => {
  let wsId = socket.id
  let param = { websocket_id: wsId }
  chat.websocketReg(param)
})
socket.on('chat message', function(msg) {
  if (msg === 'connect ok') {
  } else if (msg === 'heart beat ok') {
  } else {
    let wsMsg = utils.decodeUnicode(msg)
    state.pullMsg = utils.isJsonString(wsMsg) ? JSON.parse(wsMsg) : wsMsg
    state.loadType = 1
    state.msgTimestamp = new Date()
    state.notice_count++
    if (document.visibilityState === 'hidden') {
      socketNotify(state.pullMsg)
    }
  }
})
// 心跳
const heartBeat = () => {
  let hb = {
    action: 'heart_beat'
  }
  let hbs = JSON.stringify(hb)
  socket.emit('chat message', hbs)
}
setInterval(heartBeat, 240000)

// 浏览器通知
function socketNotify(pullMsg) {
  let noticeObj = {
    icon: 'http://img.yimutian.com/misc/5cc6948a6ef1434e6e56527198b9001d.png',
    body: pullMsg.content,
    timestamp: 3000,
    data: {
      url: location.origin + '/#/chat',
      dialog_id: pullMsg.dialog_id,
      from_id: pullMsg.from_id
    }
  }
  let notice = null
  if (!('Notification' in window)) {
    return
  } else if (Notification.permission === 'granted') {
    notice = new Notification('新消息通知', noticeObj)
  } else if (Notification.permission !== 'denied') {
    Notification.requestPermission(function(permission) {
      if (permission === 'granted') {
        notice = new Notification('新消息通知', noticeObj)
      }
    })
  }
  if (notice) {
    notice.onclick = function() {
      if (pullMsg.dialog_id) {
        if (Number(pullMsg.to_id) === Number(pullMsg.from_id)) {
          let idArray = pullMsg.dialog_id.replace(/c_/g, '').split('-')
          idArray.forEach(element => {
            if (Number(element) !== Number(pullMsg.from_id)) {
              state.peer_uid = Number(element)
            }
          })
        } else {
          state.peer_uid = pullMsg.from_id
        }
      }
      window.focus()
      location.href = notice.data.url
      notice.close()
    }
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations }
